import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const VerifyScreen = lazy(() => import('~/features/item-setup/pages/verify-screen'));

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/verify')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <VerifyScreen />
    </Suspense>
  ),
});
